const AnimationFilesGettersWithoutTransitions = {
  SadWithoutTransition: {
    duration: 6000,
    start: 32.5,
    end: 36.483,
    startFrame: 2039,
    endFrame: 2161,
  },
};

export const ToBiEmojis = Object.freeze({
  SurpriseLaugh: 'SurpriseLaugh',
  Surprise: 'Surprise',
  Whistle: 'Whistle',
  Sad: 'Sad',
  SadWithoutTransition: 'SadWithoutTransition',
  Wink: 'Wink',
  Yes: 'Yes',
  No: 'No',
  BigLaugh: 'BigLaugh',
  Indifferent: 'Indifferent',
  Angry: 'Angry',
  Laugh: 'Laugh',
  LaughTears: 'LaughTears',
  LaughSweat: 'LaughSweat',
  Smirk: 'Smirk',
  Smug: 'Smug',
  Blush: 'Blush',
  Grumpy: 'Grumpy',
  Birthday: 'Birthday',
  Love: 'Love',
  Pride: 'Pride',
});

export const ToBiIdleTypes = Object.freeze({
  short: 'short',
  long: 'long',
});

export const TobiTypesJson = Object.freeze({
  default: () => require('./Hi-Fi/TOBi_Default.json'),
  birthday: () => require('./Hi-Fi/TOBi_Birthday.json'),
  santa: () => require('./Hi-Fi/TOBi_Santa.json'),
  pride: () => require('./Hi-Fi/TOBi_Pride.json'),
});

export const TobiTypes = Object.freeze({
  default: 'default',
  birthday: 'birthday',
  santa: 'santa',
  pride: 'pride',
});

export const ToBiIdleAnimations = (type = ToBiIdleTypes.short) => {
  if (type === ToBiIdleTypes.short) {
    return Object.freeze({
      IdleOneShort: 'IdleOneShort',
      IdleTwoShort: 'IdleTwoShort',
      IdleThreeShort: 'IdleThreeShort',
      IdleFourShort: 'IdleFourShort',
    });
  } else {
    return Object.freeze({
      IdleOneLong: 'IdleOneLong',
      IdleTwoLong: 'IdleTwoLong',
      IdleThreeLong: 'IdleThreeLong',
      IdleFourLong: 'IdleFourLong',
    });
  }
};

export const AnimationFilesGetters = Object.freeze({
  IdleOneShort: {
    duration: 2000,
    start: 0,
    end: 1.983,
    startFrame: 0,
    endFrame: 119,
  },
  IdleTwoShort: {
    duration: 2000,
    start: 2,
    end: 3.983,
    startFrame: 120,
    endFrame: 239,
  },
  IdleThreeShort: {
    duration: 2000,
    start: 4,
    end: 5.983,
    startFrame: 240,
    endFrame: 359,
  },
  IdleFourShort: {
    duration: 2000,
    start: 6,
    end: 7.983,
    startFrame: 360,
    endFrame: 479,
  },
  IdleOneLong: {
    duration: 4000,
    start: 8,
    end: 11.983,
    startFrame: 480,
    endFrame: 719,
  },
  IdleTwoLong: {
    duration: 4000,
    start: 12,
    end: 15.983,
    startFrame: 720,
    endFrame: 959,
  },
  IdleThreeLong: {
    duration: 4000,
    start: 16,
    end: 19.983,
    startFrame: 960,
    endFrame: 1199,
  },
  IdleFourLong: {
    duration: 4000,
    start: 20,
    end: 23.983,
    startFrame: 1200,
    endFrame: 1439,
  },
  SurpriseLaugh: {
    duration: 2500,
    start: 24,
    end: 26.483,
    startFrame: 1440,
    endFrame: 1589,
  },
  Surprise: {
    duration: 2000,
    start: 26.5,
    end: 28.483,
    startFrame: 1590,
    endFrame: 1709,
  },
  Whistle: {
    duration: 4000,
    start: 28.5,
    end: 32.483,
    startFrame: 1710,
    endFrame: 1949,
  },
  Sad: {
    duration: 4000,
    start: 32.5,
    end: 36.483,
    startFrame: 1950,
    endFrame: 2189,
  },
  Wink: {
    duration: 2000,
    start: 36.5,
    end: 38.483,
    startFrame: 2190,
    endFrame: 2309,
  },
  Yes: {
    duration: 2000,
    start: 38.5,
    end: 40.483,
    startFrame: 2310,
    endFrame: 2429,
  },
  No: {
    duration: 2000,
    start: 40.5,
    end: 42.483,
    startFrame: 2430,
    endFrame: 2549,
  },
  BigLaugh: {
    duration: 2500,
    start: 42.5,
    end: 44.983,
    startFrame: 2550,
    endFrame: 2699,
  },
  Indifferent: {
    duration: 4000,
    start: 45,
    end: 48.983,
    startFrame: 2700,
    endFrame: 2939,
  },
  Angry: {
    duration: 4000,
    start: 49,
    end: 52.983,
    startFrame: 2940,
    endFrame: 3179,
  },
  Laugh: {
    duration: 2500,
    start: 53,
    end: 55.483,
    startFrame: 3180,
    endFrame: 3329,
  },
  LaughTears: {
    duration: 2500,
    start: 55.5,
    end: 57.983,
    startFrame: 3330,
    endFrame: 3479,
  },
  LaughSweat: {
    duration: 2500,
    start: 58,
    end: 60.483,
    startFrame: 3480,
    endFrame: 3629,
  },
  Smirk: {
    duration: 4000,
    start: 60.5,
    end: 64.483,
    startFrame: 3630,
    endFrame: 3869,
  },
  Smug: {
    duration: 4000,
    start: 64.5,
    end: 68.483,
    startFrame: 3870,
    endFrame: 4109,
  },
  Blush: {
    duration: 4000,
    start: 68.5,
    end: 72.483,
    startFrame: 4110,
    endFrame: 4349,
  },
  Grumpy: {
    duration: 4000,
    start: 72.5,
    end: 76.483,
    startFrame: 4350,
    endFrame: 4589,
  },
  Love: {
    duration: 4000,
    start: 76.5,
    end: 80.453,
    startFrame: 4590,
    endFrame: 4829,
  },
  Pride: {
    duration: 4000,
    start: 80.5,
    end: 84.483,
    startFrame: 4830,
    endFrame: 5069,
  },
  Birthday: {
    duration: 4000,
    start: 84.5,
    end: 88.483,
    startFrame: 5070,
    endFrame: 5309,
  },
  ...AnimationFilesGettersWithoutTransitions,
});
